import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { sectionName } from "@/lib/sections";
import { formatDate } from "@/lib/api";

export const InterviewBadge = ({ testId = "article-interview-badge" }) => (
  <span data-testid={testId} className="inline-flex items-center px-2 py-0.5 font-ui text-[10px] font-semibold uppercase tracking-[0.14em] bg-[var(--ink)] text-white">
    In their words
  </span>
);

export const ArticleMeta = ({ article, idPrefix = "article" }) => (
  <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
    <Link to={`/section/${article.section}`} className="meta !text-[var(--accent)] link-quiet" data-testid={`${idPrefix}-section-link`}>
      {sectionName(article.section)}
    </Link>
    {article.interview && <InterviewBadge testId={`${idPrefix}-interview-badge`} />}
    <span className="meta" data-testid={`${idPrefix}-date`}>{formatDate(article.published_at || article.updated_at)}</span>
  </div>
);

export const ContentNote = ({ note }) => (
  <aside data-testid="article-content-note" role="note" className="my-8 flex items-start gap-3 border-l-2 border-[#B45309] bg-[#FFFBEB] px-4 py-3 font-ui text-sm text-[#7C2D12]">
    <AlertTriangle size={16} strokeWidth={1.75} className="mt-0.5 shrink-0" />
    <p><span className="font-semibold">Content note: </span>{note}</p>
  </aside>
);
